function TradeSimulatorServiceIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="35"
      height="35"
      viewBox="0 0 35 35"
      fill="none"
    >
      <path
        d="M23.333 5.8335V27.7085"
        stroke="url(#paint0_linear_679_5525)"
        stroke-width="2.1875"
        stroke-linecap="round"
      />
      <path
        d="M23.333 5.8335V27.7085"
        stroke="black"
        stroke-opacity="0.2"
        stroke-width="2.1875"
        stroke-linecap="round"
      />
      <path
        d="M11.667 11.6665L11.667 27.7082"
        stroke="url(#paint1_linear_679_5525)"
        stroke-width="2.1875"
        stroke-linecap="round"
      />
      <path
        d="M11.667 11.6665L11.667 27.7082"
        stroke="black"
        stroke-opacity="0.2"
        stroke-width="2.1875"
        stroke-linecap="round"
      />
      <rect
        x="8.38574"
        y="18.5938"
        width="6.5625"
        height="6.5625"
        rx="1.82292"
        fill="url(#paint2_linear_679_5525)"
      />
      <rect
        x="8.38574"
        y="18.5938"
        width="6.5625"
        height="6.5625"
        rx="1.82292"
        fill="black"
        fill-opacity="0.2"
      />
      <rect
        x="8.38574"
        y="18.5938"
        width="6.5625"
        height="6.5625"
        rx="1.82292"
        stroke="url(#paint3_linear_679_5525)"
        stroke-width="2.1875"
      />
      <rect
        x="8.38574"
        y="18.5938"
        width="6.5625"
        height="6.5625"
        rx="1.82292"
        stroke="black"
        stroke-opacity="0.2"
        stroke-width="2.1875"
      />
      <rect
        x="20.0518"
        y="11.3022"
        width="6.5625"
        height="13.8542"
        rx="1.82292"
        fill="url(#paint4_linear_679_5525)"
      />
      <rect
        x="20.0518"
        y="11.3022"
        width="6.5625"
        height="13.8542"
        rx="1.82292"
        fill="black"
        fill-opacity="0.2"
      />
      <rect
        x="20.0518"
        y="11.3022"
        width="6.5625"
        height="13.8542"
        rx="1.82292"
        stroke="url(#paint5_linear_679_5525)"
        stroke-width="2.1875"
      />
      <rect
        x="20.0518"
        y="11.3022"
        width="6.5625"
        height="13.8542"
        rx="1.82292"
        stroke="black"
        stroke-opacity="0.2"
        stroke-width="2.1875"
      />
      <defs>
        <linearGradient
          id="paint0_linear_679_5525"
          x1="23.333"
          y1="-1.19775"
          x2="24.5884"
          y2="-1.18939"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#003ED9" />
          <stop offset="1" stop-color="#6EBDF9" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_679_5525"
          x1="11.667"
          y1="6.51025"
          x2="12.9223"
          y2="6.52166"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#003ED9" />
          <stop offset="1" stop-color="#6EBDF9" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_679_5525"
          x1="7.29199"
          y1="14.6875"
          x2="18.0485"
          y2="16.2555"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#003ED9" />
          <stop offset="1" stop-color="#6EBDF9" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_679_5525"
          x1="7.29199"
          y1="14.6875"
          x2="18.0485"
          y2="16.2555"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#003ED9" />
          <stop offset="1" stop-color="#6EBDF9" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_679_5525"
          x1="18.958"
          y1="5.05225"
          x2="29.8741"
          y2="5.92018"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#003ED9" />
          <stop offset="1" stop-color="#6EBDF9" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_679_5525"
          x1="18.958"
          y1="5.05225"
          x2="29.8741"
          y2="5.92018"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#003ED9" />
          <stop offset="1" stop-color="#6EBDF9" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default TradeSimulatorServiceIcon;
